import { customerBaseApi } from "@/react/services/api/api";
import { SMS_CHANNELS } from "../constants";
import { smsChannelsPath } from "../urls";
import { KEY } from "@/react/components/table/useTableMutations";
import schema from "@/react/features/vcc/sms-channels/schema";
import { handleMutationResponse } from "@/react/services/api/handleMutationResponse";

export const smsChannelsApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getSmsChannels: build.query({
      query: (tenantName) => ({
        url: smsChannelsPath(tenantName),
        method: "GET",
      }),
      providesTags: [SMS_CHANNELS],
    }),
    createSmsChannels: build.mutation({
      query: ({ tenantName, requestList }) => ({
        url: smsChannelsPath(tenantName),
        method: "POST",
        // List of tuples {didId, thirdParty}
        body: requestList,
      }),
      providesTags: [SMS_CHANNELS],
    }),
  }),
});

export const { useGetSmsChannelsQuery, useCreateSmsChannelsMutation } =
  smsChannelsApi;

export const handleCreateResponse = ({
  rowsToCreate,
  setRowsToCreate,
  setData,
}) =>
  handleMutationResponse({
    rows: rowsToCreate,
    setRows: setRowsToCreate,
    setData,
    responseMappingKey: schema.fields.phoneNumber.spec.key,
    idKey: KEY,
    notifyContent: (successfulMutationCount, mutationCount) =>
      `${successfulMutationCount}/${mutationCount} sms channel${
        mutationCount === 1 ? "" : "s"
      } provisioned`,
  });
